const getResourceIdFromURLParam = (paramId) => paramId.split('-')[1];
const getValidationIdFromURLParam = (paramId) => paramId.split('-')[2];
const generateResourceURLFromParam = (paramId) => `${getResourceIdFromURLParam(paramId)}-${getValidationIdFromURLParam(paramId)}`;
const generateResourceURL = (resourceId, orgId) => `${resourceId}-${(parseInt(resourceId, 10) + parseInt(orgId, 10))}`;
export {
  getResourceIdFromURLParam,
  generateResourceURL,
  getValidationIdFromURLParam,
  generateResourceURLFromParam,
};
